export default __webpack_public_path__ + "static/media/logo5.33bae74d.png";